
import api from 'api';
import { processPromise, obj2Prams } from '@helpers/functions';

const lista = {};

lista.retrieve = (params = {}) => {
  const querystring = obj2Prams(params);

  return new Promise((resolve, reject) => {
    let endpoint = `/listas`;
    endpoint = querystring ? `${endpoint}?${querystring}` : endpoint;

    api.get(endpoint).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

lista.save = (_id, file, data) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/lista`;
    endpoint = _id ? `${endpoint}/${_id}` : endpoint;

    const formData = new FormData();
    formData.append('file', file);

    for (const key in data) {
      formData.append(key, data[key]);
    }

    api.post(endpoint, formData,  { headers: { 'Content-Type': 'multipart/form-data' }}).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

lista.export = (_id) => {
  return new Promise((resolve, reject) => {
    let endpoint = `/lista`;
    endpoint = _id ? `${endpoint}/${_id}` : endpoint;
    api.patch(endpoint, {},{ responseType: 'blob' }).then((result) => {
      const response = processPromise(true, result)
      resolve(response);
    }).catch((error) => {
      processPromise(false, error)
      reject(error);
    });
  });
}

export default lista
